import catalogReducer from './catalogReducer';

export default catalogReducer;